@if(notice()) {
  <div role="status" class="response-notice text-content">{{notice()}}</div>
}
@if (review(); as report) {
  <article class="website-review border border-borderColor text-content" aria-label="Website report">
    <header class="review-header">
      <span class="material-icons-outlined review-icon" aria-hidden="true">travel_explore</span>
      <div><h2>{{reportName() || 'Website report'}}</h2><p class="report-name">{{reportName() ? 'Website report' : 'Report summary'}}@if(summaryOnly()) { · Keyword summary }@if(reportDate()) { · Scan date: {{reportDate() | date:'mediumDate'}} }</p></div>
      <span class="review-label">NovaAI</span>
    </header>
    <div class="review-body">
    @if(reportPath()) {
      <a class="open-report" [href]="reportPath()" target="_blank" rel="noopener noreferrer">Open report <span class="material-icons-outlined" aria-hidden="true">open_in_new</span></a>
    }
    @if(report.url) {
    <a class="source-link" [href]="report.url" target="_blank" rel="noopener noreferrer"
      aria-label="Open scanned page in a new tab">
      <span class="material-icons-outlined" aria-hidden="true">language</span>
      <span class="source-text"><strong>{{report.hostname}}</strong><span class="source-url">{{report.url}}</span></span>
      <span class="material-icons-outlined" aria-hidden="true">open_in_new</span>
    </a>
    }
    @if(report.summary) {
    <h3>What stands out</h3>
    <div class="review-prose quick-read" [innerHTML]="report.summary"></div>
    }
    @if (report.nextStep) {
      <section class="next-step">
        <h3>Suggested next step</h3>
        <div class="review-prose" [innerHTML]="report.nextStep"></div>
      </section>
    }
    @if(report.intro || report.sourceNote || report.highlights.length || report.sections.length) {
    <details class="details">
      <summary><span class="material-icons-outlined" aria-hidden="true">expand_more</span>View details</summary>
      <div class="detail-content">
        @if (report.intro) { <div class="review-prose" [innerHTML]="report.intro"></div> }
        @if (report.sourceNote) { <div class="review-prose" [innerHTML]="report.sourceNote"></div> }
        @if (report.highlights.length) {
          <section>
            <h3>Report findings</h3>
            <ul class="scan-overview">
              @for (highlight of report.highlights; track $index) {
                <li class="review-prose" [innerHTML]="highlight.html"></li>
              }
            </ul>
            <p class="scan-caption">These are scan flags, not confirmed violations.</p>
          </section>
        }
        @for (section of report.sections; track $index) {
          <section>@if(section.title) { <h3>{{section.title}}</h3> }<div class="review-prose" [innerHTML]="section.html"></div></section>
        }
      </div>
    </details>
    }
    </div>
  </article>
} @else if(content() && (state() === 'answer' || state() === 'streaming' || state() === 'partial')) {
  <div class="ordinary-response border border-borderColor text-content"><div class="prose break-words" [innerHTML]="content() | markdown"></div></div>
}
